export default __webpack_public_path__ + "static/media/success.372b0b41.svg";